export const pageTitle = {
  margin: "20px 0 20px 0",
};

export const filtersContainer = {
  marginBottom: "20px",
};

export const reportSelect = {
  marginLeft: "10px",
};

export const filterSection = {
  marginTop: "30px",
  textAlign: "left",
};

export const filterRow = {
  marginBottom: "12px",
  display: "flex",
  alignItems: "center",
};

export const filterLabel = {
  width: "140px",
  fontSize: "14px",
};

export const filterSelect = {
  padding: "5px",
  flex: 1,
};

export const hanoverSelectButtonStyle = {
  margin: 0,
  marginTop: 0,
  width: "auto",
  padding: "4px 10px",
  fontSize: "13px",
  borderRadius: "2px",
  borderWidth: "1px",
};

export const hanoverDropdownContainer = {
  flex: 1,
  position: "relative",
};

export const hanoverTrigger = {
  padding: "5px 8px",
  width: "100%",
  textAlign: "left",
  cursor: "pointer",
  border: "1px solid #767676",
  borderRadius: "2px",
  background: "#fff",
  fontSize: "14px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const hanoverTriggerLabel = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const hanoverTriggerIcon = {
  marginLeft: "8px",
};

export const hanoverDropdownPanel = {
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  zIndex: 1000,
  marginTop: "2px",
  background: "#fff",
  border: "1px solid #767676",
  borderRadius: "2px",
  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
};

export const hanoverDropdownActions = {
  display: "flex",
  gap: "8px",
  padding: "8px",
  borderBottom: "1px solid #e0e0e0",
};

export const hanoverDropdownOptions = {
  minHeight: "112px",
  maxHeight: "200px",
  overflowY: "auto",
  padding: "8px",
};

export const hanoverOptionLabel = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "6px",
  fontSize: "14px",
  cursor: "pointer",
};

export const downloadButtonLabel = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
};

export const downloadButton = {
  marginLeft: "10px",
};
